import { useState, useEffect, useCallback } from "react";
import { Box, Stack, Text, Paper, Loader, Center } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import trpc from "@/shared/utils/trpc";
import { handleTrpcError } from "@/shared/utils/trpc/handletrpcError.util";
import CompanyCardHorizontal from "@/components/shared/CompanyCardHorizontal";
import TitleComponent from "@/components/shared/TitleComponent";

import { useUserContext } from "@/context/UserContext";

export default function CollaborationsPage() {
  const navigate = useNavigate();
  const { hasProfile } = useUserContext();
  const [collaborations, setCollaborations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCollaborations = useCallback(async () => {
    if (hasProfile === null) return;
    setLoading(true);
    try {
      const collaborationsData = await trpc.collaboration.getActive.query();
      setCollaborations(collaborationsData);
    } catch (err) {
      handleTrpcError(err);
      setCollaborations([]);
    } finally {
      setLoading(false);
    }
  }, [hasProfile]);

  useEffect(() => {
    fetchCollaborations();
  }, [fetchCollaborations]);

  const handleViewProfile = (companyId: string) => {
    const collaboration = collaborations.find((c) => c.company?.id === companyId);
    if (collaboration) {
      navigate(`/collaborations/${collaboration.id}`);
    }
  };

  const handleSignNda = (companyId: string) => {
    navigate(`/interests/${companyId}/nda`);
  };

  if (loading) {
    return (
      <Box mih="100vh" pb={20}>
        <TitleComponent title="Collaborations" description="Manage incoming and outgoing collaboration requests" />
        <Center py="xl" mih="50vh">
          <Loader size="lg" />
        </Center>
      </Box>
    );
  }

  return (
    <Box mih="100vh" pb={20}>
      <TitleComponent title="Collaborations" description="Manage incoming and outgoing collaboration requests" />

      <Box p="md">
        <Stack gap="md">
          {collaborations.length === 0 ? (
            <Paper p="xl" radius="lg" withBorder>
              <Text c="slate.5" ta="center">
                No active collaborations yet
              </Text>
            </Paper>
          ) : (
            collaborations.map((collaboration) => (
              <CompanyCardHorizontal
                key={collaboration.id}
                company={collaboration.company}
                onShortlistClick={() => {}}
                onViewDetails={handleViewProfile}
                showShortlistButton={false}
                isCollaborationList={true}
                ndaStatus={collaboration.ndaStatus}
                onSignNda={handleSignNda}
              />
            ))
          )}
        </Stack>
      </Box>
    </Box>
  );
}
